<script>
export default {
  name: 'DesktopWarning',
  data () {
    return {}
  },
}
</script>

<template>
  <div id="desktop-warning">  
    <img class='image' src="/assets/errors/error_desktop.svg" />
  </div>
</template>

<style scoped lang="scss">
#desktop-warning {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #191919;
  @include flexbox(center-vertical); 

  .image {
    width: 30%;
    height: auto;
  }
}
</style>
